import * as React from 'react';
import { Component } from 'react';
import i18n from 'i18n';
import Col from 'react-bootstrap/Col';
import { BlazeTableColDef } from 'components/blazeTable/BlazeTable.types';
import { FilterType, StateChangesDetailsType } from 'types/rest/analyticsTypes';
import BlazeTable from 'components/blazeTable/BlazeTable';
import Row from 'react-bootstrap/Row';
import OutdatedRequest from 'views/Analytics/AnalyticsMockService/Inspection/RequestDetail/OutdatedRequest';
import FullPageLoader from 'components/loaders/FullPageLoader';
import clsx from 'clsx';

interface StateChangesDetailsStatelessProps {
  tabId: any;
  isLoading: boolean;
  stateChangesName: any;
  isOutdated: boolean;
  changedRowsCount: number;
  filters: FilterType[];
  details: StateChangesDetailsType[];
  onRefresh: (tabId: any) => void;
}

/**
 * Inspection detail of StateChanges.
 */
class StateChangesDetails extends Component<StateChangesDetailsStatelessProps> {
  tableRef: any = React.createRef<BlazeTable>();

  // Definition of table columns
  colsDefinition: BlazeTableColDef[] = [
    {
      header: i18n.t('analytics:stateChanges.detail.key'),
      width: 30,
      accessor: 'key',
    },
    {
      header: i18n.t('analytics:stateChanges.detail.value'),
      width: 70,
      accessor: 'value',
    },
  ];

  getTableOptions = () => ({
    showRowExpander: false,
    columnDef: this.colsDefinition,
    pageable: true,
    selectable: false,
    pageSize: 5,
    minWidth: 950,
    minHeight: 150,
    tableName: 'stateChangesDetails',
    noResultsText: i18n.t('analytics:stateChanges.table.noResults'),
    customHeaderClassName: 'flex-table-item-top',
    customTableClassName: 'flex-table-simple flex-table-condensed',
    maxContentHeight: '185px',
  });

  render() {
    const title = 'Details of State Change';
    const { text, be } =
      this.props.changedRowsCount === 1 ? { text: 'Object', be: 'was' } : { text: 'Objects', be: 'were' };
    const filter = this.props.filters.length === 1 ? 'filter' : 'filters';
    return (
      <div className="mt-4 pt-4 position-relative" style={{ borderTop: '1px solid #c8d1e0', minHeight: '400px' }}>
        {this.props.isLoading && (
          <div className="blur-background">
            <FullPageLoader />
          </div>
        )}

        <div className={this.props.isLoading ? 'blur' : ''}>
          {/* Header */}
          {this.props.isOutdated === false && (
            <div className="mb-2 mt-2" style={{ minHeight: 30 }}>
              <Row className="mt-3 mb-3">
                <Col lg={10} md={7} sm={6}>
                  <h2 className="mb-0 text-truncate pt-2" title={title + this.props.stateChangesName}>
                    <span className="ml-3">
                      {title}:<span className="text-muted ml-2 mr-2">{this.props.stateChangesName}</span>
                    </span>
                  </h2>
                </Col>
                <Col className={'text-right'} lg={2} md={5} sm={6}></Col>
              </Row>
              {this.props.filters.length > 0 && (
                <Row className="mt-3 mb-3">
                  <Col lg={10} md={7} sm={6}>
                    <span className="ml-3">
                      <span className="font-weight-semi-bold">
                        {this.props.changedRowsCount} {text}
                      </span>{' '}
                      following {filter}{' '}
                    </span>
                    {this.props.filters.map((f, index) => (
                      <span key={index} className={clsx('badge', 'badge-attention', 'mr-2')} style={{ padding: '5px' }}>
                        <span className="font-weight-semi-bold">{f.key + ' ' + f.operation + ' ' + f.values}</span>
                      </span>
                    ))}
                    <span>{be} updated about values listed bellow.</span>
                  </Col>
                  <Col className={'text-right'} lg={2} md={5} sm={6}></Col>
                </Row>
              )}
            </div>
          )}
          {/* Outdated Request Placeholder */}
          {this.props.isOutdated === true && (
            <OutdatedRequest refreshRequestsHandler={() => this.props.onRefresh(this.props.tabId)} />
          )}
          {/* Render body only when details are ready */}
          <div className="position-relative">
            <BlazeTable
              options={this.getTableOptions()}
              data={this.props.details}
              onRef={(ref: any) => (this.tableRef = ref)}
              showPageSizeDropdown={true}
            />
          </div>
        </div>
      </div>
    );
  }
}

export default StateChangesDetails;
